<template>
  <div class="household-editor">
    <el-select
      class="operator-select"
      v-model="row.operator"
      size="small"
      placeholder="请选择"
    >
      <el-option
        v-for="op in operatorList"
        :key="op.value"
        :label="op.label"
        :value="op.value"
      ></el-option>
    </el-select>

    <div class="household-display">
      <span class="household-list" :title="displayText">{{ displayText }}</span>
      <el-button
        v-if="!readonly"
        class="edit-text-button"
        type="text"
        icon="el-icon-edit"
        size="mini"
        @click="showHouseholdDialog"
        >编辑</el-button
      >
    </div>

    <el-dialog
      title="户籍地管理"
      :visible.sync="householdDialogVisible"
      width="600px"
    >
      <div class="household-content">
        <div class="add-section">
          <el-button type="primary" size="small" @click="showAddHouseholdDialog"
            >新增户籍地</el-button
          >
        </div>
        <div class="list-section">
          <el-table :data="householdList" style="width: 100%">
            <el-table-column label="序号" width="80">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="name" label="地区名称" min-width="200">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="editHousehold(scope.row, scope.$index)"
                  >编辑</el-button
                >
                <el-button
                  type="danger"
                  size="mini"
                  @click="deleteHousehold(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="householdDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button type="primary" @click="saveHousehold" size="small"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="新增户籍地"
      :visible.sync="addHouseholdDialogVisible"
      width="400px"
    >
      <el-form
        :model="householdForm"
        :rules="householdRules"
        ref="householdForm"
        label-width="80px"
      >
        <el-form-item label="地区名称" prop="name">
          <el-input
            v-model="householdForm.name"
            placeholder="请输入地区名称"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="addHouseholdDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button type="primary" @click="confirmAddHousehold" size="small"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStrategyOperatorList } from "./strategy-operator";

export default {
  name: "HouseholdEditor",

  props: {
    row: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      householdDialogVisible: false,
      householdList: [],
      addHouseholdDialogVisible: false,
      householdForm: {
        name: "",
      },
      householdRules: {
        name: [
          { required: true, message: "地区名称不能为空", trigger: "blur" },
        ],
      },
      editingIndex: undefined,
    };
  },

  computed: {
    operatorList() {
      return getStrategyOperatorList(this.row);
    },
    displayText() {
      const hits = this.row.hits || [];
      return hits.length ? hits.join("，") : "暂无户籍地";
    },
  },

  methods: {
    // 编辑副本，只有保存管理弹窗时才回写策略。
    showHouseholdDialog() {
      this.householdList = (this.row.hits || []).map((name) => ({ name }));
      this.householdDialogVisible = true;
    },
    showAddHouseholdDialog() {
      this.householdForm.name = "";
      this.editingIndex = undefined;
      this.addHouseholdDialogVisible = true;
    },
    editHousehold(row, index) {
      this.householdForm.name = row.name;
      this.editingIndex = index;
      this.addHouseholdDialogVisible = true;
    },
    deleteHousehold(index) {
      this.$confirm("确定要删除这个户籍地吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.householdList.splice(index, 1);
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },
    confirmAddHousehold() {
      this.$refs.householdForm.validate((valid) => {
        if (!valid) return;
        if (this.editingIndex !== undefined) {
          this.$set(this.householdList, this.editingIndex, {
            name: this.householdForm.name,
          });
          this.$message.success("编辑成功");
          this.editingIndex = undefined;
        } else {
          this.householdList.push({ name: this.householdForm.name });
          this.$message.success("新增成功");
        }
        this.addHouseholdDialogVisible = false;
        this.householdForm.name = "";
      });
    },
    // hits 按接口约定保存地区名称数组。
    saveHousehold() {
      this.$set(this.row, "hits", this.householdList.map((item) => item.name));
      this.householdDialogVisible = false;
      this.$message.success("户籍地管理保存成功");
    },
  },
};
</script>

<style lang="scss" scoped>
.household-editor {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;

  .operator-select {
    width: 120px;
    margin-right: 20px;
    flex-shrink: 0;
  }

  .household-display {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;

    .edit-text-button {
      flex-shrink: 0;
      padding: 0;
      font-size: 14px;
      font-weight: 400;
    }

    .household-list {
      flex: 1;
      min-width: 0;
      margin-right: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  /deep/ .el-dialog .el-dialog__body {
    padding-top: 0;
  }

  /deep/ .el-dialog .el-table {
    overflow-y: scroll;

    &::before {
      display: none;
    }

    .el-table__cell {
      padding: 8px 0;
    }
  }

  /deep/ .household-content {
    .add-section {
      margin-bottom: 20px;
    }

    .el-table__header th {
      background-color: #f5f5f5;
      color: #1a1e25;
    }
  }
}
</style>
